import {
  getThingAll,
  getUrlAll,
  SolidDataset,
  Thing,
  ThingLocal,
  ThingPersisted,
} from '@inrupt/solid-client'
import { isThingLocal } from '@inrupt/solid-client/dist/thing/thing'
import { CompletedQuestion } from '../models/CompletedQuestion'
import { Question } from '../models/Question'
import { Survey } from '../models/Survey'
import { URI } from './ontology'

const isThingPersisted = (
  thing: ThingLocal | ThingPersisted
): thing is ThingPersisted => !isThingLocal(thing)

export function getQuestionsFromDataSet(
  dataset: SolidDataset
): { survey: Survey | undefined; questions: Question[] } {
  const survey = Survey.fromDataset(dataset)
  if (!survey) {
    return { survey: undefined, questions: [] }
  }
  if (!survey.startsWith) {
    return { survey, questions: [] }
  }
  const things: Thing[] = getThingAll(dataset)
  const questions = things
    .filter(t =>
      getUrlAll(t, URI.TYPE_PREDICATE).includes(
        URI.SURVEY_SINGLE_INPUT_QUESTION_CLASS
      )
    )
    .filter<ThingPersisted>(isThingPersisted)
    .map(t => new Question(t))

  const first = questions.find(q => survey.startsWith === q.url)
  if (!first) {
    return { survey, questions: [] }
  }
  const ordered: Question[] = [first]
  let next: Question | undefined = first
  while (next !== undefined) {
    next = questions.find(q => q.url === next?.leadsTo)
    if (next) {
      ordered.push(next)
    }
  }

  return { survey, questions: ordered }
}

export function getCompletedQuestionsFromResponseDataset(
  responseDataset: SolidDataset
): { completedQuestions: CompletedQuestion[] } {
  const responseThings: Thing[] = getThingAll(responseDataset)
  const completedQuestions = responseThings
    .filter(t =>
      getUrlAll(t, URI.TYPE_PREDICATE).includes(
        URI.SURVEY_COMPLETED_QUESTION_CLASS
      )
    )
    .filter<ThingPersisted>(isThingPersisted)
    .map(t => new CompletedQuestion(t))

  return { completedQuestions }
}

export const lastSegment = (path: string): string =>
  path.substring(path.lastIndexOf('/') + 1)

export const extractId = (fileName: string): string => {
  const r = new RegExp(/^survey-(.+)\.ttl/).exec(fileName)
  if (!r || r.length === 0) {
    return ''
  }
  return r[1]
}
